import { StatusType } from "../../types";
import { PosApiRequest } from "../pos-api-request";

export class StatusRequest extends PosApiRequest {
  public StatusType: StatusType;
}
